'use client';
import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';
import Image from 'next/image';

export default function BenefitItem({
  icon,
  title,
  description,
  index,
  buyBox,
  size,
  productModal,
  modalIcon
}) {
  const { showModal } = useModal();

  const handleClick = () => {
    showModal(MODAL_TYPES.benefit, {
      index,
      title,
      description,
      icon,
      modalIcon,
      productModal
    });
  };

  const iconImage = icon.url;
  const iconSize = size === 'small' ? 38 : 60;
  const labelStyle = buyBox
    ? 'body-xs block max-w-[96px] text-white'
    : 'sh11 sm:sh9 lg:mt-3';
  const containerStyle = buyBox
    ? 'cursor-pointer'
    : 'grow px-4 flex flex-col justify-between cursor-pointer';

  return (
    <>
      <div onClick={handleClick} className={containerStyle}>
        <Image
          src={iconImage}
          alt={icon.title.replace(/\.[^/.]+$/, '')}
          width={iconSize}
          height={iconSize}
          sizes="(min-width: 1200px) 60px, 38px"
          className={`mx-auto mb-2 ${buyBox && 'benefit-icon'}`}
        />
        {buyBox ? (
          <div className={labelStyle}>{title}</div>
        ) : (
          <>
            <h3 className={labelStyle}>{title}</h3>
            <div className="body-s sm:body-r mt-3 content-center">
              <span className="txt-btn-secondary">Learn more</span>
            </div>
          </>
        )}
      </div>
    </>
  );
}
